module.exports = __webpack_public_path__ + "static/feature-shot-2-7615a9a20449500c4f5cadd15607f829.jpg";